import React, {useEffect, useState} from 'react';
import {Grid,} from "@material-ui/core";
import {
  BoughtTogether,
  DetailsSection,
  Footer,
  ImageSection,
  ServiceInfoSection,
  RelatedProducts,
  TopNavBar
} from '../../components'
import './style.scss'
import HttpService from "../../services/http.service";
import {withRouter} from "react-router-dom";
import Seo from "../../components/Seo";


function ProductDetail(props) {
  const product = props?.location?.state?.product
  const [activeTab, setActiveTab] = useState(0);
  const [multiImages, setMultiImages] = useState([]);
  const [related, setRelated] = useState([]);
  const [blockchain, setBlockchain] = useState(null);

  const handleChangeTab = (event, key) => {
    console.log({key})
    setActiveTab(key)
  }

  const [fullDetail, setFullDetail] = useState(false);
  useEffect(() => {
    setFullDetail(props?.location?.pathname === '/detail')
  }, [props.location])
  const onSearchClick = (item, category) => {
    props.history.push({
      pathname: '/result',
      state: {search: item, category: category}
    })
  }
  useEffect(() => {
    HttpService.post(`api/edit/getAll/${product.harvestId}`).then(res => {
      if (res && res.data) {
        setMultiImages(res.data)
      }
    })
    //blockchain/byHarvestId/2
    HttpService.post(`api/blockchain/byHarvestId/${product.harvestId}`).then(res => {
      if (res && res.data) {
        setBlockchain(res.data)
      }
    })
  }, [product.harvestId])
  useEffect(() => {
    HttpService.get(`marketplace/getProductByLocation/V3/productName/null/${product?.harvest}/null/null/null`).then(res => {
      if (res) {
        //console.log(res.data)
        setRelated(res.data)
        //setLoading(false)
      }
    });
  }, [product]);
  return (
    <>
      <Seo
        title={product?.harvest || 'Service'}
        description={product?.harvest ? `${product.harvest} — a verified service on AgriLive's fair marketplace.` : undefined}
        path={`/serviceDetail/${product?.harvestId || ''}`}
        image={product?.imagePath || undefined}
      />
      <TopNavBar onClick={onSearchClick}/>
      <Grid container className='product-detail-container after-navbar-container mt-60' style={{}}>
        <Grid container className={' p-main  content-container pt-0'} style={{padding: fullDetail ? 0 : 10,}}>
          <Grid item lg={4} md={4} sm={4} xs={12}>
            <ImageSection fullDetail={fullDetail} multiple={false} multiImages={multiImages} image={product ? product.imagePath : ''}/>
          </Grid>

          <Grid item lg={8} md={8} sm={8} xs={12}>
            <ServiceInfoSection product={product} {...props} fullDetail={true} />
          </Grid>

          <DetailsSection product={product} blockchain={blockchain} activeTab={activeTab} page={'service'}
                          handleChangeTab={handleChangeTab}/>
          {/*{related && <>*/}
          {/*  <BoughtTogether data={related}/>*/}
          {/*  <RelatedProducts data={related} history={props.history}/>*/}
          {/*</>*/}
          {/*}*/}
        </Grid>
        <Grid className='mt-60'><Footer/></Grid>

      </Grid>
    </>
  );
}

export default withRouter(ProductDetail);
